import { styled } from "@mui/material/styles";

export const LogoContainer = styled("div", {
  shouldForwardProp: (prop) => prop !== "pointer",
})<{ pointer?: boolean }>`
  display: flex;
  align-items: center;
  cursor: ${(props) => (props.pointer ? "pointer" : "auto")};
`;
